import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService as FEAuthService } from '@shared/services/auth.service';
import { AuthService as AdminAuthService } from '@admin/shared/services/admin.auth.service';
import { Observable } from 'rxjs';
import { TokensPayload } from '@shared/models/auth.model';
import { Router } from '@angular/router';

// Helper to add Authorization header
function addToken<T>(request: HttpRequest<T>, token: string): HttpRequest<T> {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const currentRoute = router.url;
  let authService: FEAuthService | AdminAuthService;
  if (currentRoute.includes('adminpanel')) {
    authService = inject(AdminAuthService);
  } else {
    authService = inject(FEAuthService);
  }
  // Always get the latest tokens from storage/service
  const tokens: TokensPayload | null = typeof authService.getToken === 'function' ? authService.getToken() : authService.authTokens;
  const requestWithToken = tokens?.access_Token ? addToken(req, tokens.access_Token) : req;
  return next(requestWithToken);
};



